import * as React from 'react';
import { PureIconContainer } from './utils/IconContainer';
var EyeHide = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_EyeHide_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.495 3.384A8.444 8.444 0 0 0 8 3C3.429 3 0 6.889 0 8c0 .604 1.014 2.03 2.674 3.205l.718-.719a9.696 9.696 0 0 1-.492-.359 8.227 8.227 0 0 1-1.494-1.48 3.435 3.435 0 0 1-.35-.548A1.235 1.235 0 0 1 1.015 8c.009-.024.022-.056.043-.1.067-.138.18-.325.349-.548A8.227 8.227 0 0 1 2.9 5.872C4.208 4.856 5.998 4 8 4c.58 0 1.142.072 1.68.199l.815-.815Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.176 4.703a3.5 3.5 0 0 0-4.474 4.474l.823-.823a2.5 2.5 0 0 1 2.83-2.83l.821-.821Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m.14 15.154 14.3-14.3a.368.368 0 0 0 .007-.008l.7-.7a.5.5 0 0 1 .707.708l-3.391 3.39C14.628 5.483 16 7.297 16 8c0 1.111-3.429 5-8 5-1.281 0-2.472-.305-3.523-.77L.854 15.855a.5.5 0 0 1-.715-.7ZM11.726 4.98l-.924.924a3.5 3.5 0 0 1-4.9 4.9l-.661.662C6.089 11.795 7.019 12 8 12c2.002 0 3.792-.855 5.1-1.873a8.223 8.223 0 0 0 1.495-1.48c.168-.222.281-.409.348-.548A1.24 1.24 0 0 0 14.986 8a1.24 1.24 0 0 0-.043-.1 3.433 3.433 0 0 0-.348-.548 8.223 8.223 0 0 0-1.495-1.48 9.63 9.63 0 0 0-1.373-.892Zm-1.641 1.641L6.62 10.086a2.5 2.5 0 0 0 3.465-3.465Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_EyeHide_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
export default EyeHide;